<template>
  <b-container fluid>
    <b-row>
      <b-col sm="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">Công thức</h4>
          </template>
          <template v-slot:body>
            <b-button v-b-modal.modal-formular-1 variant="primary" class="mb-4 mt-2">
              <i class="las la-plus"/> Thêm mới
            </b-button>
            <tab-nav :tabs="true" id="myTab-1">
                <tab-nav-items v-for="(network, index) in networks" :key="network.id" :active="index == 0 ? true : false" :id="`network-${network.id}`" :ariaControls="`home-${network.id}`" role="tab" :ariaSelected="index == 0 ? true : false" :title="network.name" @clicked="changeNetworkChoose(network.id)"/>
            </tab-nav>
            <hr>
            <tab-content id="myTabContent">
              <tab-content-item :active="true" aria-labelled-by="home-tab">
                <div class="table-responsive">
                  <b-table
                    id="formular-list-table"
                    ref="formularListTableRef"
                    :items="formularList"
                    :fields="formularFields"
                    :striped="false"
                    :outlined="true"
                    :small="true"
                    :hover="true"
                    :primary-key="'id'"
                    class="table-striped table-bordered table-align-middle"
                    role="grid"
                  >
                    <template v-slot:cell(currency_id)="data">
                      {{ moneyTypeByServerId(data.item.currency_id).text }}
                    </template>
                    <template v-slot:cell(type_money)="data">
                      <b-badge variant="red" v-if="data.item.type_money === '1'">Nhận</b-badge>
                      <b-badge variant="green" v-if="data.item.type_money === '0'">Giao</b-badge>
                    </template>
                    <template v-slot:cell(formular_type)="data">
                      {{data.item.formula_type.name}}
                    </template>

                    <template v-slot:cell(value)="data">
                      <div class="text-left">
                        <p>Hệ số: <b>{{ data.item.ratio }}</b></p>
                        <hr style="margin: 0px -8px;">
                        <p>Giá thầu: <b>{{ data.item.price }}</b></p>
                      </div>
                    </template>

                    <template v-slot:cell(action)="data">
                      <div class="flex align-items-center list-user-action">
                        <a
                          class="iq-bg-primary"
                          data-toggle="tooltip"
                          data-placement="top"
                          @click="confirmDelete(data.item.id, data.item.name)"
                        >
                          <i class="las la-trash-alt text-red"></i>
                        </a>
                      </div>
                    </template>
                  </b-table>
                </div>
              </tab-content-item>
            </tab-content>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <formular-create-modal modal-id="modal-formular-1" :network-id="selectedNetwork"/>
  </b-container>
</template>
<script>
import _ from 'lodash'
import api from '../../store/api'
import { findash } from '../../config/pluginInit'
import { mapActions, mapGetters } from 'vuex'
import FormularCreateModal from '../../components/application/formular/FormularCreateModal'

export default {
  name: 'FormularList',
  components: {
    FormularCreateModal
  },
  async mounted () {
    findash.index()

    if (this.networks[0]) { this.changeNetworkChoose(this.networks[0].id) }
  },
  watch: {
    networks: function (newVal, oldVal) {
      // first time load
      if (oldVal.length === 0 && this.networks) {
        this.changeNetworkChoose(this.networks[0].id)
      }
    }
  },
  data () {
    return {
      formularFields: [
        {
          key: 'name',
          label: 'Tên công thức'
        },
        {
          key: 'currency_id',
          label: 'Loại tiền',
          class: 'text-center',
          thStyle: { width: '20%' }
        },
        {
          key: 'type_money',
          label: 'Giao/Nhận',
          class: 'text-center'
        },
        {
          key: 'formular_type',
          label: 'Loại',
          class: 'text-center'
        },
        {
          key: 'value',
          label: 'Giá trị',
          class: 'text-center'
        },
        {
          key: 'action',
          label: '',
          class: 'text-center',
          thStyle: { width: '5%' }
        }
      ],
      selectedNetwork: null
    }
  },
  computed: {
    ...mapGetters({
      'networks': 'Network/listState',
      'moneyTypes': 'Setting/moneyTypeState',
      'formularList': 'Formular/listByNetworkState'
    })
  },
  methods: {
    ...mapActions({
      loadListByNetwork: 'Formular/loadListByNetwork'
    }),
    async changeNetworkChoose (networkId) {
      this.selectedNetwork = networkId

      this.isBusy = true

      // action
      await this.loadListByNetwork({ 'network_id': this.selectedNetwork })

      this.isBusy = false
    },
    moneyTypeByServerId (serverId) {
      return _.first(_.filter(this.moneyTypes, (item) => {
        return item.serverId === parseInt(serverId)
      }))
    },
    confirmDelete (id, name) {
      this.$swal({
        title: name,
        text: 'Bạn chắc chắn xóa công thức này ?',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Xóa',
        denyButtonText: `Hủy`
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          api.formular.delete(id).then(async () => {
            this.$swal({
              icon: 'success',
              title: 'Xóa thành công'
            })

            // load list
            this.changeNetworkChoose(this.selectedNetwork)
          }).catch(() => {
            this.$swal({
              icon: 'error',
              title: 'Lỗi...',
              text: this.serverError
            })
          })
        } else if (result.isDenied) {

        }
      })
    }

  }
}
</script>
